// extracted by mini-css-extract-plugin
export default {"flexed":"styles_flexed__eu34g","spaceBetween":"styles_spaceBetween__f-1qh"};